import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// eslint-disable-next-line max-len
import { ResponsiveModalWrapperComponent } from '@shared/components/modal/responsive-modal-wrapper/responsive-modal-wrapper.component';
import { SharedPipesModule } from '@shared/pipes/shared-pipes/shared-pipes.module';
import { ModalWrapperComponent } from './modal-wrapper/modal-wrapper.component';
import { ModalContentComponent } from './modal-content/modal-content.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { ModalContainerComponent } from './modal-container/modal-container.component';

@NgModule({
  exports: [
    ModalWrapperComponent,
    ModalContentComponent,
    ResponsiveModalWrapperComponent,
    ModalContainerComponent
  ],
  declarations: [
    ModalWrapperComponent,
    ModalContentComponent,
    ResponsiveModalWrapperComponent,
    ModalContainerComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    SharedPipesModule
  ],
})
export class ModalModule {}
